export class Image{
    // TODO stringに統一したい
    id : number | string = 0;
    name : string = "デザインなし"
    imagePath : string = ""
    imageData : string = ""
    recentUsedAt : number = 0
}

